import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function usePageTitle(pageTitle) {
  const location = useLocation();

  useEffect(() => {
    document.title = `PrayerSend - ${pageTitle}`;
  }, [pageTitle, location.pathname]);
}